import { colors } from '@resurs/midas'

export default {
  board: {
    background: 'white',
    overflow: 'hidden',
    border: '1px solid',
    borderColor: colors.gray5,
    padding: '1.5rem 2rem 2rem',
  },
  title: {
    color: colors.gray1,
    marginTop: '3px',
    marginBottom: '10px',
  },
  period: {
    color: colors.gray2,
  },
  scope: {
    background: 'white',
  },
  timespan: {
    display: 'inline-block',
    background: colors.gray4,
  },
  neutral: {
    active: {
      background: colors.gray2,
    },
  },
  charttype: {
    display: 'inline-block',
    background: colors.gray4,
  },
}
